import { SubjectData } from 'shell/models/person';
import { ParentVM } from 'civil-status/view-models/step-form';
import { initialValuesParent } from 'civil-status/constants/initial-values-step';

export const transformerCivilUnionSpouse = (person: SubjectData): ParentVM | undefined => {
  if (!Boolean(person.unioneCivile?.unitoCivilmente)) {
    return;
  }

  const coniuge = person.unioneCivile?.unitoCivilmente || {};
  const isConiugeWithFiscalCode = Boolean(coniuge.codiceFiscale?.codFiscale);

  return {
    searchPerson: isConiugeWithFiscalCode
      ? { fiscalCode: coniuge.codiceFiscale?.codFiscale }
      : undefined,
    generality: {
      ...initialValuesParent.generality,
      name: coniuge.nome || '',
      surname: coniuge.cognome || '',
      gender: coniuge.sesso || '',
    },
  };
};
